(() => {
  const dnsHero = document.querySelector("[data-dns-hero]");
  const heroImage = document.querySelector("[data-hero-image]");
  const heroContent = document.querySelector("[data-hero-content]");

  if (dnsHero && heroImage && heroContent) {
    setTimeout(() => {
      if (heroImage.offsetHeight > 0) {
        dnsHero.style.minHeight = `${heroImage.offsetHeight}px`;
        heroImage.style.height = `${heroImage.offsetHeight}px`;
        heroContent.classList.add("align-top");
      }
    }, 2000);
  }
})();
